import { useRouter } from 'next/router';

import { Paragraph } from '@zillow/constellation-10';

import {
  useIsOnReviewStep,
  useMultiplexDetails,
  useMultiplexListingFlow,
} from '../../../../../hooks/queries/multiplex';
import { useGetListingDetails } from '../../../../../hooks/queries/properties';

import { wizardParagraphStyles } from '../../../../../styles/wizard';

import LeaseTermsFormField from '../../../../PostingPath/LeaseTermsFormField';
import RentersInsuranceFormField from '../../../../PostingPath/RentersInsuranceFormField';

export const LeaseTermsIntroAndFields = () => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const isOnReviewStep = useIsOnReviewStep();
  const { data: listingDetails } = useGetListingDetails(listingAlias);
  const { data: multiplexData } = useMultiplexDetails({ enabled: !isOnReviewStep });
  const { isInMultiplexListingFlow } = useMultiplexListingFlow();

  const rentersInsurance =
    !isInMultiplexListingFlow || isOnReviewStep
      ? listingDetails?.rentersInsurance
      : (multiplexData?.rentersInsurance ?? listingDetails?.rentersInsurance);

  const showRentersInsurance = rentersInsurance?.isEligibleForIsRentersInsuranceRequiredQuestion;

  return (
    <>
      <Paragraph css={wizardParagraphStyles}>
        Help renters decide if your property’s a good fit by including key lease details like duration, fees and utility
        costs, and other policies.
      </Paragraph>

      <LeaseTermsFormField />

      {showRentersInsurance && <RentersInsuranceFormField />}
    </>
  );
};
